<template>
  <div class="package-pop">
    <el-dialog
      v-if="visible"
      title="收货地址"
      width="1074px"
      :visible.sync="visible"
    >
      <div slot="title"></div>
      <div slot="footer"></div>
      <div class="price-container">
        <span class="close el-icon-guanbi" data-track-text="关闭套餐弹窗" aria-label="关闭套餐弹窗" @click="close()"></span>
        <div
          class="price-item"
          :class="[currentItem.id === item.id ? 'select' : '']"
          v-for="item in priceList"
          :key="item.id"
        >
          <div class="price-name">
            {{ item.priceName }}
          </div>
          <div
            class="price-priceRmb"
            :class="[item.priceRmb === 0 ? 'active' : '']"
          >
            {{ getPriceString(item) }}
          </div>
          <div class="price-priceDesc">{{ item.priceDesc }}</div>
          <div
	            class="price-btn"
	            :class="[item.priceRmb === 0 ? 'free' : '']"
	            :data-track-text="item.priceRmb === 0 ? '免费使用套餐' : '购买套餐'"
	            :aria-label="item.priceRmb === 0 ? '免费使用套餐' : '购买套餐'"
	            @click="createOrder(item)"
          >
            {{ item.priceRmb === 0 ? "免费使用" : "立即购买" }}
          </div>
          <div class="price-content">
            <div class="ai-num item">
              <span>AI翻译对话</span>
              <span class="right">{{
                item.aiChatNum === 999999999 ? "无限制" : item.aiChatNum + "次"
              }}</span>
            </div>
            <div class="ai-change item">
              <span>语言大模型选择</span>
              <span class="right" :class="[item.llmChange ? 'active' : '']">{{
                item.llmChange ? "√" : "x"
              }}</span>
            </div>
            <div class="ai-polish item">
              <span>AI润色改写</span>
              <span class="right" :class="[item.aiPolish ? 'active' : '']">{{
                item.aiPolish ? "√" : "x"
              }}</span>
            </div>
            <div class="ai-ppt item">
              <span>AI一键生成 PPT</span>
              <span class="right">{{
                item.aiPptNum === 999999999
                  ? "无限制"
                  : item.aiPptNum === 0
                  ? "x"
                  : item.aiPptNum + "次"
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "PackagePop",
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      priceList: [],
      currentItem: {},
    };
  },
  watch: {},
  computed: {},
  mounted() {},
  methods: {
    createOrder(item) {
      if (item.priceRmb === 0) {
        return;
      }
      this.$http
        .get("https://user.wesitrans.com/api/price/createOrder", {
          params: {
            id: item.id,
          },
        })
        .then((res) => {
          if (res.data) {
            window.open(process.env.VUE_APP_PAY + res.data, "_self");
            return;
          }
          this.$message({
            type: "info",
            message: "请稍后再试!",
          });
        })
        .catch((error) => {
          this.$message({
            type: "info",
            message: "请稍后再试!",
          });
        });
    },
    getPriceString(item) {
      if (item.priceRmb === 0) {
        return "免费";
      } else {
        return `￥${item.priceRmb}/${item.priceUnit === "month" ? "月" : "年"}`;
      }
    },
    getPrice() {
      this.$http
        .get("https://user.wesitrans.com/api/price/list")
        .then((res) => {
          this.priceList = res.data;
          this.currentItem = this.priceList.find(
            (item) => item.priceType === "default"
          );
        });
    },
    open() {
      this.visible = true;
      this.getPrice();
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.package-pop {
  /deep/.el-dialog {
    background: url(../../assets/chat/bg.jpg) center no-repeat;
    background-size: 100% 100%;
  }
  /deep/.el-dialog__header {
    display: none;
  }
  /deep/.el-dialog__footer {
    display: none;
  }
  /deep/.el-dialog__body {
    padding: 0;
  }
  .price-container {
    display: flex;
    width: 1074px;
    height: 660px;
    gap: 40px;
    align-items: center;
    justify-content: center;
    position: relative;
    .close {
      position: absolute;
      right: 24px;
      top: 30px;
      cursor: pointer;
      font-size: 18px;
    }
    .price-item {
      width: 280px;
      height: 480px;
      text-align: center;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(32, 31, 38, 0.14);
      border-radius: 4px;
      border: 1px solid #ebeff5;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      &:hover {
        box-shadow: 0px 0px 13px 0px rgba(150, 101, 0, 0.8);
        border-radius: 4px;
        border: 2px solid #966500;
        .price-btn {
          background: #966500;
          border-radius: 6px;
          font-size: 18px;
          color: #ffffff;
        }
        .price-priceRmb {
          color: #966500;
        }
      }
      .price-name {
        font-weight: bold;
        font-size: 20px;
        color: #000000;
        margin-top: 50px;
      }
      .price-priceRmb {
        font-weight: bold;
        font-size: 30px;
        color: #000000;
        margin-top: 8px;
        &.active {
          color: #966500;
        }
      }
      .price-priceDesc {
        font-size: 16px;
        color: #000000;
        margin-top: 10px;
      }
      .price-btn {
        width: 180px;
        height: 50px;
        background: #ffffff;
        border-radius: 6px;
        border: 1px solid #966500;
        font-size: 18px;
        color: #966500;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        margin-top: 20px;
        &.free {
          color: #966500 !important;
          background: #ffffff !important;
        }
      }
      .price-content {
        line-height: 40px;
        width: 228px;
        margin-top: 40px;
        .item {
          font-size: 14px;
          color: #333333;
          border-bottom: 1px solid #eeeeee;
          display: flex;
          justify-content: space-between;
          .right {
            width: 50px;
            text-align: left;
            &.active {
              color: #966500;
            }
          }
        }
      }
    }
  }
}
</style>
